'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dPush$002dNotification from "./app.api.-Pharmacy-App-Update$-Push-Notification.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$PushNotification$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$PushNotification$ as $c_Lapp_api_PharmacyAppUpdate$PushNotification$ };
$c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$PushNotification$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$PushNotification$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$PushNotification$ as $h_Lapp_api_PharmacyAppUpdate$PushNotification$ };
$h_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype = $c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype;
$c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype.toString__T = (function() {
  return "PushNotification";
});
$c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$PushNotification = (function(x$0) {
  var data$5 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dPush$002dNotification.$c_Lapp_api_PharmacyAppUpdate$PushNotification(data$5);
});
$c_Lapp_api_PharmacyAppUpdate$PushNotification$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$PushNotification(p);
});
var $d_Lapp_api_PharmacyAppUpdate$PushNotification$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$PushNotification$, "app.api.PharmacyAppUpdate$PushNotification$", ({
  Lapp_api_PharmacyAppUpdate$PushNotification$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$PushNotification$ as $d_Lapp_api_PharmacyAppUpdate$PushNotification$ };
var $n_Lapp_api_PharmacyAppUpdate$PushNotification$;
function $m_Lapp_api_PharmacyAppUpdate$PushNotification$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$PushNotification$)) {
    $n_Lapp_api_PharmacyAppUpdate$PushNotification$ = new $c_Lapp_api_PharmacyAppUpdate$PushNotification$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$PushNotification$;
}
export { $m_Lapp_api_PharmacyAppUpdate$PushNotification$ as $m_Lapp_api_PharmacyAppUpdate$PushNotification$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Push-Notification$.js.map
